module.exports = __webpack_public_path__ + "static/media/invalidCred.e50a4351.svg";